import { inject, Injectable } from "@angular/core";
import {
	GetStakingUserJourneyGQLService,
	GetStakingUserJourneyQuery
} from "../../../../api/graphql/staking/generated/auto-staking.user-journey.service.graphql-gen";
import { catchError, map } from "rxjs/operators";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { InfoService } from "@core-services/info.service";
import { ExceptionsService } from "@core-services/exceptions.service";
import {
	GetSettingsGQLService,
	GetSettingsQuery
} from "../../../../api/graphql/staking/generated/auto-staking.state.service.graphql-gen";
import {
	UpdateSettingsGQLService,
	UpdateSettingsMutation
} from "../../../../api/graphql/staking/generated/auto-staking.update-state.service.graphql-gen";
import { UpdateSettingActionInput } from "@gql/staking";

@Injectable({
	providedIn: "root"
})
export class AutoStakingRemote {
	private readonly stakingUserJourneyService = inject(GetStakingUserJourneyGQLService);
	private readonly infoService = inject(InfoService);
	private readonly exceptionsService = inject(ExceptionsService);
	private readonly autoStakingOptedInService = inject(GetSettingsGQLService);
	private readonly autoStakingStateMutationService = inject(UpdateSettingsGQLService);

	public getStakingUserJourney$(): Observable<GetStakingUserJourneyQuery | string> {
		return this.stakingUserJourneyService.watch({}, { fetchPolicy: "network-only" }).valueChanges.pipe(
			map(({ data }) => data),
			catchError(this.exceptionsService.extractGqlErrorAndRethrow),
			catchError((error) => {
				this.infoService.handleApiError(error);
				return of("error");
			})
		);
	}

	public fetchAutoStakingState$(): Observable<GetSettingsQuery> {
		return this.autoStakingOptedInService.watch({}, { fetchPolicy: "network-only" }).valueChanges.pipe(
			map(({ data }) => data),
			catchError(this.exceptionsService.extractGqlErrorAndRethrow),
			catchError((error) => {
				this.infoService.handleApiError(error);
				return EMPTY;
			})
		);
	}

	public updateAutoStakingState$(state: UpdateSettingActionInput): Observable<UpdateSettingsMutation> {
		return this.autoStakingStateMutationService.mutate({ input: state }).pipe(
			map(({ data }) => data),
			catchError(this.exceptionsService.extractGqlErrorAndRethrow),
			catchError((error) => {
				this.infoService.handleApiError(error);
				return throwError(() => error);
			})
		);
	}
}
